<div class="spinner-container" *ngIf="isLoading$ | async">
  <div class="spinner">
    <div class="loading-text">Loading...</div>
  </div>
</div>
